import React from 'react'
import styled, { css } from 'styled-components'

export interface DcFormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  condition?: React.CSSProperties
  children: React.ReactNode
  asDivIfNested?: boolean // new prop to optionally render as div
}

const StyledDcForm = styled.form.attrs<{ as?: keyof JSX.IntrinsicElements }>(
  (props) => ({
    as: props.as,
  }),
)<{ condition?: React.CSSProperties }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  ${(props) =>
    props.condition &&
    css`
      ${props.condition.width && `width: ${props.condition.width};`}
      ${props.condition.height && `height: ${props.condition.height};`}
      ${props.condition.backgroundColor &&
      `background-color: ${props.condition.backgroundColor};`} // Add more as needed
    `}
`

export const DcForm = React.forwardRef<HTMLFormElement, DcFormProps>(
  ({ children, condition, asDivIfNested = false, ...rest }, ref) => {
    const tag = asDivIfNested ? 'div' : 'form'
    return (
      <StyledDcForm ref={ref} as={tag} condition={condition} {...rest}>
        {children}
      </StyledDcForm>
    )
  },
)

DcForm.displayName = 'DcForm'

export default DcForm
